import { Component,ViewChild, AfterViewInit ,Inject,ChangeDetectorRef} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MatPaginator, MatSort} from '@angular/material';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { DataUserService } from '../../../Services/data-user.service';
import { DataApiService } from '../../../Services/data-api.service';
import { DialogCopyPedidoComponent } from '../../../components/dialogs/dialog-copy-pedido/dialog-copy-pedido.component';
import { VerDatosUsuarioPorServicioComponent } from '../../../components/dialogs/ver-datos-usuario-por-servicio/ver-datos-usuario-por-servicio.component';
import { VerConstanciaComponent } from '../../../components/dialogs/ver-constancia/ver-constancia.component';
export interface DialogData { 
  email:string;
}
@Component({
  selector: 'app-ver-constancias-de-cargo',
  templateUrl: './ver-constancias-de-cargo.component.html',
  styleUrls: ['./ver-constancias-de-cargo.component.scss']
})
export class VerConstanciasDeCargoComponent implements AfterViewInit {
  
 
  exampleDatabase: ExampleHttpDatabase | null;
  data: GithubIssue[] = [];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  itemPerPage = 8;
  idUser = this.DataUser.dataUser(this.dataApi.tokenUser(localStorage.getItem("token")));
  typeUser = localStorage.getItem("type");
  typeUserEmpresa = localStorage.getItem("tipoUsuarioEmpresa"); 

 
  displayedColumns: string[] = [
    'id_pedido'
  ];
  
  public error = null;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private http: HttpClient,    
    private DataUser:DataUserService,
    private dataApi:DataApiService,
    private dialog: MatDialog,   
    public dialogRef: MatDialogRef<VerConstanciasDeCargoComponent>,
    @Inject(MAT_DIALOG_DATA) public data2: DialogData 
  ) { }

  errorPriceNoNumeric:string= null;

   /*buscar empresa */
   buscarEmpresas(e){
    const company = e.target.value !="" ? e.target.value  : "all" ;
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.exampleDatabase!.getRepoIssues(this.idUser,this.sort.active, this.sort.direction, this.paginator.pageIndex);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;

          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);  

  }

  verDatosUsuario(row){
    this.dialog.open(VerDatosUsuarioPorServicioComponent,{
      width:"40%",
      data:{row},
      disableClose: false,
      autoFocus:true
    }); 
  
  }

  ngAfterViewInit() {
    console.log(this.idUser)
    this.exampleDatabase = new ExampleHttpDatabase(this.http,this.dataApi);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.exampleDatabase!.getRepoIssues(this.idUser,this.sort.active, this.sort.direction, this.paginator.pageIndex);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;

          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);  
  }

  

  verConstancia(row){    
    this.dialog.open(VerConstanciaComponent,{
      width:"350px",
      data:{datos:row},
      disableClose: false,
      autoFocus:true
    }); 
   
  } 
  
}

export interface GithubApi {
  items: GithubIssue[];
  total_count: number;
}

export interface GithubIssue {
  id_pedido:number,  
  usuario_asignado:string,
  constancia:string,
  tipo_usuario:number,
  name:string,
  surname:string,
  nombre_comercial:string,
  fecha_por_atender:string,
  fecha_recogido:string,
  fecha_entregado:string,
  fecha_devolucion:string,
  fecha_anulado:string
  
  
}

/** An example database that the data source uses to retrieve data for the table. */
export class ExampleHttpDatabase{
  constructor(private http: HttpClient,
    private dataApi:DataApiService) {}

  getRepoIssues(idUser:number,sort: string, order: string, page: number): Observable<GithubApi> {     
    const href = this.dataApi.url;
    const requestUrl =
        `${href}/mostrarConstanciasDeCargo/${page + 1}/8/${idUser}`;

    return this.http.get<GithubApi>(requestUrl);
  }

 
  
}

